<script>
    import { _ } from "svelte-i18n";
    import { links } from "svelte-routing";
</script>

<main
    class="p-4 w-full lg:max-w-screen-lg mx-auto flex flex-col items-center
    text-center">
    <h1>{$_("Home.Title")}</h1>
    <h2 class="mt-4 text-blue-500">{$_("Home.WhatIsACMS")}</h2>
    <p>{$_("Home.CMSExplanation")}</p>
    <h2 class="mt-4 text-blue-500">{$_("Home.WhatContent")}</h2>
    <p>{$_("Home.ContentExplanation")}</p>
    <ul use:links class="text-blue-500 mt-4">
        <li><a href="/courses">{$_("Courses.Title")}</a></li>
        <li><a href="/categories">{$_("Categories.Title")}</a></li>
        <li><a href="/blog">{$_("Blog.Title")}</a></li>
        <li><a href="/about_page">{$_("About.Page")}</a></li>
        <li><a href="/about">{$_("About.Pages")}</a></li>
        <li><a href="/homepage">{$_("HomePage.Page")}</a></li>
        <li><a href="/assets">{$_("Assets.Title")}</a></li>
    </ul>
</main>
